import React, {useCallback, useEffect, useRef, useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {useNavigate} from 'react-router-dom';
import {
  setActiveSub,
  setBearerToken,
  setCurrentSubDetails,
  setExistingSub,
  setExistingSubDetails,
  setLoading,
  setPasswordState,
  setRefreshToken,
  setUserName,
} from './features/user/userSlice';
import queryString from 'query-string';
import {setPortNumber} from './features/app/appSlice';
import {checkActiveNoSub, checkUserForSub} from './Utility/checkUserForSub';
import {axiosInstance} from './api/axios/AxiosInstance';

const Auth = props => {
  const emailRef = useRef();
  const passRef = useRef();
  const [errorMsg, setErrorMsg] = useState(null);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const isLoading = useSelector(state => state.user.isLoading);
  let values = queryString.parse(window.location.search);

  useEffect(() => {
    //console.log('querystring params', values);
    window?.localStorage.clear();
    if (values?.port) {
      dispatch(setPortNumber(values?.port));
    }
    if (values?.token && values?.refreshToken) {
      console.log(values?.token, values?.refreshToken);
      window?.localStorage?.setItem('refreshToken', values?.refreshToken);
      window?.localStorage?.setItem('bearerToken', values?.token);
      dispatch(setRefreshToken(values?.refreshToken));
      dispatch(setBearerToken(values?.token));
      navigate(`/toplist`);
    }
  }, []);

  const handleNavToSignUp = useCallback(() => {
    navigate('/signup');
  }, []);

  const handleRemoveErrorText = () => {
    dispatch(setLoading(false));
    setErrorMsg(null);
  };

  const handleSubmit = useCallback(
    e => {
      e.preventDefault();
      dispatch(setLoading(true));
      axiosInstance
        .post(
          `/auth/login?Username=${emailRef.current.value}&Password=${passRef.current.value}&Product=pilot`,
          {},
        )
        .then(res => {
          if (res?.data?.Email) {
            //navigate to watchlist screen
            console.log('authenticated with pilot ---- set jwt token here');
            window?.localStorage?.setItem('refreshToken', res?.data?.Refresh);
            window?.localStorage?.setItem('bearerToken', res?.data?.Token);
            //remove once login is done
            dispatch(setRefreshToken(res?.data?.Refresh));
            dispatch(setBearerToken(res?.data?.Token));
            dispatch(setUserName(emailRef.current.value));
            dispatch(setPasswordState(passRef.current.value));
            if (res.data?.Subscriptions) {
              res.data?.Subscriptions?.forEach(sub => {
                if (sub?.Subscribed) {
                  dispatch(setCurrentSubDetails(sub));
                } else {
                  dispatch(setExistingSubDetails(sub));
                }
              });
            }
            //check if the user has an active subscription
            dispatch(setActiveSub(checkUserForSub(res?.data)));
            dispatch(setExistingSub(checkActiveNoSub(res?.data)));
            navigate('/subexpired');
            dispatch(setLoading(false));
          }
        })
        .catch(err => {
          console.log(err?.response?.data?.Message);
          setErrorMsg('Invalid username or password');
        });
    },
    [emailRef, passRef, navigate],
  );

  return (
    <div className="Auth-form-container">
      <form className="Auth-form" onSubmit={handleSubmit}>
        <div className="Auth-form-content">
          <h3 className="Auth-form-title">Sign In</h3>
          <div className="form-group mt-3">
            <label>Email address</label>
            <input
              ref={emailRef}
              onChange={handleRemoveErrorText}
              id="email"
              type="email"
              className="form-control mt-1"
              placeholder="Enter email"
            />
          </div>
          <div className="form-group mt-3">
            <label>Password</label>
            <input
              ref={passRef}
              onChange={handleRemoveErrorText}
              id="password"
              type="password"
              className="form-control mt-1"
              placeholder="Enter password"
            />
          </div>
          <p className="forgot-password text-right mt-2">
            <label>{errorMsg}</label>
          </p>
          <div className="d-grid mt-2">
            {isLoading ? (
              <button disabled className="btn btn-primary">
                <span
                  className="spinner-border spinner-border-sm"
                  role="status"
                  aria-hidden="true"
                ></span>
                Loading...
              </button>
            ) : (
              <button type="submit" className="btn btn-primary">
                Submit
              </button>
            )}
          </div>
          <div className="d-grid mt-2">
            <button onClick={handleNavToSignUp} className="btn btn-primary">
              Sign Up
            </button>
          </div>
        </div>
      </form>
    </div>
  );
};

export default Auth;
